import { Link } from "react-router-dom";
import Seo from "../../components/Seo";
import Hero from "../../components/marketing/Hero";
import FeatureGrid from "../../components/marketing/FeatureGrid";
import HowItWorks from "../../components/marketing/HowItWorks";
import "./Home.css";

const MODULES = [
  "Dashboard overview",
  "Branch management",
  "Staff & permissions",
  "Client records",
  "Service catalog",
  "Appointment calendar",
  "Follow-up queue",
  "Messaging campaigns",
  "Website content",
  "Inquiries inbox",
];

const Home = () => (
  <>
    <Seo
      title="Carely IT — Organization Management Platform"
      description="Manage your organization in one place — appointments, clients, staff, follow-ups, and your own website."
      canonicalPath="/"
    />
    <Hero />

    <section className="trust-strip">
      <p className="trust-strip__text">
        Built for multi-branch service organizations — one platform for every
        location, role, and client conversation.
      </p>
    </section>

    <FeatureGrid />
    <HowItWorks />

    <section className="modules">
      <div className="modules__inner">
        <header className="modules__header">
          <p className="modules__eyebrow">Inside the product</p>
          <h2 className="modules__title">
            A complete admin workspace, not a patchwork
          </h2>
          <p className="modules__lead">
            Every module your team touches during the day lives in the same
            place, under the same login.
          </p>
        </header>
        <ul className="modules__list">
          {MODULES.map((module) => (
            <li key={module} className="modules__item">
              {module}
            </li>
          ))}
        </ul>
      </div>
    </section>

    <section className="final-cta">
      <div className="final-cta__inner">
        <div className="final-cta__card">
          <h2 className="final-cta__title">Already have an account?</h2>
          <p className="final-cta__text">
            Login to pick up where your team left off.
          </p>
          <Link to="/login" className="final-cta__btn final-cta__btn--primary">
            Login
          </Link>
        </div>
        <div className="final-cta__card final-cta__card--accent">
          <h2 className="final-cta__title">Want Carely IT for your organization?</h2>
          <p className="final-cta__text">
            We'll set everything up with you — no self-serve registration.
          </p>
          <a
            href="tel:01916707697"
            className="final-cta__btn final-cta__btn--light"
          >
            Call 01916707697
          </a>
          <a className="final-cta__email" href="mailto:zonayed@carelyit.com">
            or email zonayed@carelyit.com
          </a>
        </div>
      </div>
    </section>
  </>
);

export default Home;
